export const styles = () => ({
  container: {
    display: 'flex',
    textAlign: 'center' as 'center',
    justifyContent: 'flex-end',
    padding: '0px 16px',
  },
});
